import { useState } from 'react';
import apiService from '../../axios/apiService';
import { useLocation } from 'react-router-dom';
import { getSearchParamFromLocation } from '../../utils/mapper';
import { message } from 'antd';

export const useInvoiceUpdate = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const updateInvoice = async (data) => {
    // Update invoice
    setLoading(true);
    try {
      const id = getSearchParamFromLocation('id', location);
      if (!id) {
        return message.error('Please provide invoice ID');
      }
      const response = await apiService.updateInvoice(id, data);
      return response;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    updateInvoice,
  };
};
